import { useState } from 'react';

export const usePaymentPopup = () => {
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [popupMessage, setPopupMessage] = useState<string>('');
  const [popupType, setPopupType] = useState<'success' | 'cancel' | null>(null);

  const showSuccessPopup = (message: string) => {
    setPopupMessage(message);
    setPopupType('success');
    setShowPopup(true);
    
    setTimeout(() => {
      setShowPopup(false);
      setPopupType(null);
    }, 5000);
  };

  const showCancelPopup = (message: string) => {
    setPopupMessage(message);
    setPopupType('cancel');
    setShowPopup(true);
    
    setTimeout(() => {
      setShowPopup(false);
      setPopupType(null);
    }, 5000);
  };

  return {
    showPopup,
    popupMessage,
    popupType,
    showSuccessPopup,
    showCancelPopup
  };
};